/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApiGmwGeojsonList200ResponseFeaturesInnerGeometry
 */
export interface ApiGmwGeojsonList200ResponseFeaturesInnerGeometry {
  /**
   *
   * @type {ApiGmwGeojsonList200ResponseFeaturesInnerGeometryTypeEnum}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerGeometry
   */
  type: ApiGmwGeojsonList200ResponseFeaturesInnerGeometryTypeEnum;
  /**
   * [longitude, latitude]
   * @type {Array<number>}
   * @memberof ApiGmwGeojsonList200ResponseFeaturesInnerGeometry
   */
  coordinates: Array<number>;
}

/**
 * @export
 */
export const ApiGmwGeojsonList200ResponseFeaturesInnerGeometryTypeEnum = {
  Point: "Point",
} as const;
export type ApiGmwGeojsonList200ResponseFeaturesInnerGeometryTypeEnum =
  (typeof ApiGmwGeojsonList200ResponseFeaturesInnerGeometryTypeEnum)[keyof typeof ApiGmwGeojsonList200ResponseFeaturesInnerGeometryTypeEnum];

/**
 * Check if a given object implements the ApiGmwGeojsonList200ResponseFeaturesInnerGeometry interface.
 */
export function instanceOfApiGmwGeojsonList200ResponseFeaturesInnerGeometry(
  value: object
): value is ApiGmwGeojsonList200ResponseFeaturesInnerGeometry {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (value["type"] !== "Point") return false;

  if (!("coordinates" in value) || value["coordinates"] === undefined) return false;
  return true;
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerGeometryFromJSON(
  json: any
): ApiGmwGeojsonList200ResponseFeaturesInnerGeometry {
  return ApiGmwGeojsonList200ResponseFeaturesInnerGeometryFromJSONTyped(json, false);
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerGeometryFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGmwGeojsonList200ResponseFeaturesInnerGeometry {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    coordinates: json["coordinates"],
  };
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerGeometryToJSON(
  json: any
): ApiGmwGeojsonList200ResponseFeaturesInnerGeometry {
  return ApiGmwGeojsonList200ResponseFeaturesInnerGeometryToJSONTyped(json, false);
}

export function ApiGmwGeojsonList200ResponseFeaturesInnerGeometryToJSONTyped(
  value?: ApiGmwGeojsonList200ResponseFeaturesInnerGeometry | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    coordinates: value["coordinates"],
  };
}
